<template>
  <van-form  @submit="onSubmit">
    <van-collapse v-model="subActivate" @change="collapseChange" :accordion="true" >
      <van-collapse-item title="核验信息">
    <van-field
            label="账户类型:"
            label-width="100px"
            input-align="left"
            name="upper_bankType_0"
            readonly
            :rules="[{ required: true, message: '请选择要件清单类型' }]"
    >
      <template #input>
        <van-radio-group v-model="formData.upper_bankType_0" direction="horizontal" @change="onChange">
          <van-radio name="个人账户">个人账户</van-radio>
          <van-radio name="对公账户">对公账户</van-radio>
        </van-radio-group>
      </template>
    </van-field>

    <van-field
            label="账户名:"
            placeholder="请输入账户名"
            label-width="100px"
            input-align="left"
            name="upper_name_0"
            v-model="formData.upper_name_0"
            :rules="[{ required: true, message: '请输入账户名' }]"
    />

    <van-field
            label="账号:"
            placeholder="请输入账号"
            label-width="100px"
            input-align="left"
            name="upper_account_0"
            v-model="formData.upper_account_0"
            :rules="[{ required: true, message: '请输入账号' }]"
    />

    <van-field
            label="开户行:"
            placeholder="请输入开户行"
            label-width="100px"
            input-align="left"
            name="upper_bank_0"
            v-model="formData.upper_bank_0"
            :rules="[{ required: true, message: '请输入开户行' }]"
    />

    <van-field
            label="关闭手机银行:"
            label-width="100px"
            input-align="left"
            name="upper_phoneClose_0"
            readonly
            :rules="[{ required: true, message: '请选择' }]"
    >
      <template #input>
        <van-radio-group v-model="formData.upper_phoneClose_0" direction="horizontal" @change="onPhoneCloseChange">
          <van-radio name="是">是</van-radio>
          <van-radio name="否">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>

    <van-field  v-if="phoneCloseShow"
            label="说明原因:"
            placeholder="请输入说明原因"
            label-width="100px"
            input-align="left"
            name="upper_reason_0"
            v-model="formData.upper_reason_0"
            :rules="[{ required: true, message: '请输入说明原因' }]"
    />

    <template v-if="upperBankTypeShow">
      <van-field
              label="核对是否开办支票、支票相关信息:"
              label-width="100px"
              input-align="left"
              name="upper_checkInfo_0"
              readonly
      >
        <template #input>
          <van-radio-group v-model="formData.upper_checkInfo_0" direction="horizontal" >
            <van-radio name="是">是</van-radio>
            <van-radio name="否">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
              label="核对预留印鉴(财务章，法人章，公章等):"
              label-width="100px"
              input-align="left"
              name="upper_sealImprint_0"
              readonly
      >
        <template #input>
          <van-radio-group v-model="formData.upper_sealImprint_0" direction="horizontal" >
            <van-radio name="已核对">已核对</van-radio>
          </van-radio-group>
        </template>
      </van-field>
    </template>

    <van-field
            readonly
            clickable
            name="upper_method_0"
            :value="formData.upper_method_0"
            label="转账验证方式:"
            placeholder="点击选择"
            label-width="100px"
            input-align="left"
            @click="showMethod0 = true"
            :rules="[{ required: true, message: '请选择' }]"
    />
    <van-popup v-model="showMethod0" position="bottom">
      <van-cell
              title="已选择"
              left>
        <template>
          <van-tag plain round closeable type="success"  size="medium"  v-for="(item,index) in methodSelected" @close="onMethodSelectedClose(item)" @click="onMethodClose(item)">{{item}}</van-tag>
        </template>
      </van-cell>

      <van-picker
              show-toolbar
              :columns="methods"
              @confirm="onMethodConfirm"
              @cancel="showMethod0 = false"
              @change="onMethodChange"
      />
    </van-popup>

    <van-field
                label="预留手机号:"
                placeholder="请输入预留手机号"
                label-width="100px"
                input-align="left"
                name="upper_phone_0"
                v-model="formData.upper_phone_0"
                :rules="[{ required: true, message: '请输入预留手机号' }]"
    />

    <van-field
            label="转账限额单笔:"
            placeholder="请输入转账限额单笔"
            label-width="100px"
            input-align="left"
            name="upper_dayLimit_0"
            v-model="formData.upper_dayLimit_0"
            :rules="[{ required: true, message: '请输入转账限额单笔' }]"
    />

    <van-field
            label="转账限额单日:"
            placeholder="请输入转账限额单日"
            label-width="100px"
            input-align="left"
            name="upper_countLimit_0"
            v-model="formData.upper_countLimit_0"
            :rules="[{ required: true, message: '请输入转账限额单日' }]"
    />

    <van-field
            label="原网银登录密码:"
            placeholder="请输入原网银登录密码"
            label-width="100px"
            input-align="left"
            name="upper_oldPassWord_0"
            v-model="formData.upper_oldPassWord_0"
            :rules="[{ required: true, message: '请输入原网银登录密码' }]"
    />

    <van-field
            label="网银登录新密码:"
            placeholder="请输入网银登录新密码"
            label-width="100px"
            input-align="left"
            name="upper_newPassWord_0"
            v-model="formData.upper_newPassWord_0"
            :rules="[{ required: true, message: '请输入网银登录新密码' }]"
    />

    <van-field
            label="原U盾密码:"
            placeholder="请输入原U盾密码"
            label-width="100px"
            input-align="left"
            name="upper_oldUPassWord_0"
            v-model="formData.upper_oldUPassWord_0"
            :rules="[{ required: true, message: '请输入原U盾密码' }]"
    />

    <van-field
            label="U盾新密码:"
            placeholder="请输入U盾新密码"
            label-width="100px"
            input-align="left"
            name="upper_newUPassWord_0"
            v-model="formData.upper_newUPassWord_0"
            :rules="[{ required: true, message: '请输入U盾新密码' }]"
    />

    <van-field
            label="原取款密码:"
            placeholder="请输入原取款密码"
            label-width="100px"
            input-align="left"
            name="upper_oldBankPassW_0"
            v-model="formData.upper_oldBankPassW_0"
            :rules="[{ required: true, message: '请输入原取款密码' }]"
    />

    <van-field
            label="取款新密码:"
            placeholder="请输入取款新密码"
            label-width="100px"
            input-align="left"
            name="upper_newBankPassW_0"
            v-model="formData.upper_newBankPassW_0"
            :rules="[{ required: true, message: '请输入取款新密码' }]"
    />

    <van-field
            label="账户余额:"
            placeholder="请输入账户余额"
            label-width="100px"
            input-align="left"
            name="upper_balance_0"
            v-model="formData.upper_balance_0"
            :rules="[{ required: true, message: '请输入账户余额' }]"
    />

    <van-field
            label="验证转账"
            label-width="100px"
            input-align="left"
            name="upper_checkConvert_0"
            readonly
    >
      <template #input>
        <van-radio-group v-model="formData.upper_checkConvert_0" direction="horizontal" >
          <van-radio name="是">是</van-radio>
          <van-radio name="否">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>

    <van-field
            label="备注:"
            placeholder="请输入备注"
            label-width="100px"
            input-align="left"
            name="upper_remark_0"
            v-model="formData.upper_remark_0"
            :rules="[{ required: true, message: '请输入备注' }]"
    />

    </van-collapse-item>
    <van-collapse-item title="附件">
      <!--<FilesUpload style="margin-top: 10px;" :applyId="applyId" :groupCode="920" refName="upperMajor" :isUpload="isEdit"></FilesUpload>-->
      <oss-upload style="margin-top: 10px;" :applyId="applyId" :groupCode="920" refName="upperMajor" :isUpload="isEdit"></oss-upload>
    </van-collapse-item>
    </van-collapse>

    <div style="margin: 16px;" v-if="isEdit">
      <van-button round block type="info" native-type="submit" :loading="loading">
        保存
      </van-button>
    </div>
  </van-form>

</template>

<script>
import { debounce,cloneDeep } from 'lodash'
import {saveFormData,getFormData} from '@/api/foreclosure'
import FilesUpload from '../../business/mortgage/files-upload'
import ossUpload from '@/views/component/oss-upload'
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
export default {
  name: 'upper_major',
  props: {
    applyId: {
      type: String,
      default: ''
    },
    isEdit:{
      type:Boolean,
      default:false
    }
  },
  components: {
      FilesUpload,
      ossUpload
  },
  data() {
    return {
      formData:{},
      edit: false,
      loading: false,
      phoneCloseShow:false,
      upperBankTypeShow:false,
      showMethod0:false,
      methodSelected:[],
      methods:['U盾','密码器','验证码','柜台划款'],
      subActivate: [],
      list: [
        {
          label: '账户类型',
          ext: 'upper_bankType_0',
          info: ''
        },
        {
          label: '账户名',
          ext: 'upper_name_0',
          info: ''
        },
        {
          label: '账号',
          ext: 'upper_account_0',
          info: ''
        },
        {
          label: '开户行',
          ext: 'upper_bank_0',
          info: ''
        },
        {
          label: '关闭手机银行',
          ext: 'upper_phoneClose_0',
          info: ''
        },
        {
          label: '说明原因',
          ext: 'upper_reason_0',
          info: ''
        },
        {
          label: '核对是否开办支票、支票相关信息',
          ext: 'upper_checkInfo_0',
          info: ''
        },
        {
          label: '核对预留印鉴(财务章，法人章，公章等)',
          ext: 'upper_sealImprint_0',
          info: ''
        },
        {
          label: '转账方式',
          ext: 'upper_method_0',
          info: ''
        },
        {
          label: '预留手机号',
          ext: 'upper_phone_0',
          info: ''
        },
        {
          label: '转账限额单笔',
          ext: 'upper_countLimit_0',
          info: ''
        },
        {
          label: '转账限额单日',
          ext: 'upper_dayLimit_0',
          info: ''
        },
        {
          label: '原登录密码',
          ext: 'upper_oldPassWord_0',
          info: ''
        },
        {
          label: '新密码',
          ext: 'upper_newPassWord_0',
          info: ''
        },
        {
          label: '原U盾密码',
          ext: 'upper_oldUPassWord_0',
          info: ''
        },
        {
          label: '新密码',
          ext: 'upper_newUPassWord_0',
          info: ''
        },
        {
          label: '银行卡原密码',
          ext: 'upper_oldBankPassW_0',
          info: ''
        },
        {
          label: '银行卡新密码',
          ext: 'upper_newBankPassW_0',
          info: ''
        },
        {
          label: '账户余额',
          ext: 'upper_balance_0',
          info: ''
        },
        {
          label: '验证转账',
          ext: 'upper_checkConvert_0',
          info: ''
        },
        {
          label: '备注',
          ext: 'upper_remark_0',
          info: ''
        }
      ]
    }
  },
  mounted() {
    let self = this
    this.loadData()
  },
  methods: {
    loadData() {
      let self = this
      let params = {
        applyId: this.applyId,
        formModule:'F_UpperMajor'
      }
      getFormData(params).then(res => {
        if (res.success) {
          let field={}
          res.data!=null&&res.data.forEach((item,index)=>{
            if(item.ext=='upper_bankType_0'&&item.info=='对公账户'){
              self.upperBankTypeShow=true
            }
            if(item.ext=='upper_phoneClose_0'&&item.info=='否'){
              self.phoneCloseShow=true
            }
            if(item.ext=='upper_method_0'){
                self.methodSelected=(item.info!=null?item.info.split(","):[])
            }
            field[item.ext]=item.info
          })
          debounce(() => {
            self.formData=field
          }, 1000)()
        }
      })
    },
    onSubmit(values){
        let params=cloneDeep(values)
        this.handleParams(params)
        let data={}
        data.applyId = this.applyId
        data.list = this.list
        data.formModule='F_UpperMajor'
        this.loading=true
        saveFormData(data).then(res=>{
            if(res.success){
                Toast.success(res.msg);
            }else{
                Toast.fail(res.msg);
            }
            this.loading=false
        })
    },
    handleParams(params) {
      let self=this
      this.list.forEach((item,index)=>{
          item.info=params[item.ext]
      })
    },
    onChange(value){
      this.upperBankTypeShow=(value=='对公账户')
    },
    onPhoneCloseChange(value){
      this.phoneCloseShow=(value=='否')
    },
    onMethodClose(value){
        if(this.methodSelected.includes(value))
            this.methodSelected.splice(this.methodSelected.findIndex(item => item===value), 1)
    },
    onMethodConfirm(value){
        this.formData.upper_method_0 = this.methodSelected.join(",");
        this.showMethod0 = false;
    },
    onMethodChange(option,value,index){
        if(!this.methodSelected.includes(value))
            this.methodSelected.push(value)
    },
    collapseChange(array) {
    },
  }
}
</script>
